document.addEventListener('DOMContentLoaded', () => {
  const consentMode = JSON.parse(localStorage.getItem('consentMode')) || {};
  const consentModeAdStorage = consentMode.ad_storage ?? window.defaultConsentMode.ad_storage ?? 'granted';

  document.cookie = `vo_ad_storage=${consentModeAdStorage}; max-age=${30 * 24 * 60 * 60}; path=/`;
  // eslint-disable-next-line no-console
  console.log('consentModeAdStorage:', consentModeAdStorage);
});
